export const Logo = ({ className = "w-10 h-10" }) => (
  <img src="/logo-leaf.png" alt="Mimi Tao golden leaf logo" className={`${className} object-contain`} data-testid="site-logo" />
);
